const LIGHT = {
  bgApp:    "#F5F4F1",
  bgCard:   "#FFFFFF",
  bgHover:  "#F9F8F6",
  bgInput:  "#FDFCFB",
  bgSidebar:"#FFFFFF",

  border:      "rgba(0,0,0,0.09)",
  borderHover: "rgba(0,0,0,0.18)",
  borderFocus: "#C95210",

  primary:      "#C95210",
  primaryDark:  "#A84209",
  primaryLight: "#FDF0E8",
  primaryDim:   "rgba(201,82,16,0.10)",
  accent:       "#C41040",
  accentDim:    "rgba(196,16,64,0.10)",
  grad:         "linear-gradient(135deg, #C95210 0%, #C41040 100%)",

  text0: "#1A1612",
  text1: "#3E3933",
  text2: "#6B655C",

  success:    "#15803D",
  successBg:  "#F0FDF4",
  successBdr: "rgba(21,128,61,0.2)",
  warn:       "#B45309",
  warnBg:     "#FFFBEB",
  warnBdr:    "rgba(180,83,9,0.2)",
  info:       "#1D4ED8",
  infoBg:     "#EFF6FF",
  infoBdr:    "rgba(29,78,216,0.2)",
  danger:     "#B91C1C",
  dangerBg:   "#FEF2F2",
  dangerBdr:  "rgba(185,28,28,0.2)",
  purple:     "#6D28D9",
  purpleBg:   "#F5F3FF",
  purpleBdr:  "rgba(109,40,217,0.2)",

  shadowSm: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  shadowMd: "0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)",
  shadowLg: "0 8px 30px rgba(0,0,0,0.10), 0 4px 8px rgba(0,0,0,0.04)",
  shadowXl: "0 20px 60px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.06)",
};

const DARK = {
  bgApp:    "#121212",
  bgCard:   "#1E1E1E",
  bgHover:  "#2A2A2A",
  bgInput:  "#252525",
  bgSidebar:"#1A1A1A",

  border:      "rgba(255,255,255,0.10)",
  borderHover: "rgba(255,255,255,0.18)",
  borderFocus: "#E8732A",

  primary:      "#E8732A",
  primaryDark:  "#C95210",
  primaryLight: "rgba(232,115,42,0.12)",
  primaryDim:   "rgba(232,115,42,0.15)",
  accent:       "#E84070",
  accentDim:    "rgba(232,64,112,0.15)",
  grad:         "linear-gradient(135deg, #E8732A 0%, #E84070 100%)",

  text0: "#EAEAEA",
  text1: "#C8C8D0",
  text2: "#9A9AA6",

  success:    "#4ADE80",
  successBg:  "rgba(74,222,128,0.10)",
  successBdr: "rgba(74,222,128,0.25)",
  warn:       "#FBBF24",
  warnBg:     "rgba(251,191,36,0.10)",
  warnBdr:    "rgba(251,191,36,0.25)",
  info:       "#60A5FA",
  infoBg:     "rgba(96,165,250,0.10)",
  infoBdr:    "rgba(96,165,250,0.25)",
  danger:     "#F87171",
  dangerBg:   "rgba(248,113,113,0.10)",
  dangerBdr:  "rgba(248,113,113,0.25)",
  purple:     "#A78BFA",
  purpleBg:   "rgba(167,139,250,0.10)",
  purpleBdr:  "rgba(167,139,250,0.25)",

  shadowSm: "0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.2)",
  shadowMd: "0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3)",
  shadowLg: "0 8px 30px rgba(0,0,0,0.5), 0 4px 8px rgba(0,0,0,0.3)",
  shadowXl: "0 20px 60px rgba(0,0,0,0.6), 0 8px 16px rgba(0,0,0,0.4)",
};

// T starts as light; applyTheme mutates it in-place so all `T.xxx` refs update
const T = { ...LIGHT };

export function applyTheme(isDark) {
  const src = isDark ? DARK : LIGHT;
  Object.keys(src).forEach(k => { T[k] = src[k]; });
  // Activate the [data-theme="dark"] CSS rules (scrollbars, skeleton shimmer,
  // and any var()-based styling). Previously this was never set, so those
  // dark-mode rules never applied.
  document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
  // Update CSS body background
  document.body.style.background = T.bgApp;
  document.body.style.color = T.text0;
  // Phase 36da.99.v — tell the browser to render native form controls
  // (date pickers, placeholders, scrollbars, checkboxes, file pickers)
  // with dark-mode defaults.  Without this, the date picker calendar
  // popup and <input> placeholder text use the browser's light-mode
  // UA styles even when the rest of the page is dark.
  document.documentElement.style.colorScheme = isDark ? "dark" : "light";
}

export { LIGHT, DARK };
export default T;